<template>
  <router-link-simple
    class="btn btn-primary btn-block btn-sm col-md-3 mx-auto mt-3"
    :to="urlPart"
    @click.native="scrollToTop"
  >
    {{ buttonName }}
  </router-link-simple>
</template>

<script>
// this component is used for tiptap (but can be used anywhere else)

import RouterLinkSimple from './RouterLinkSimple.vue';

export default {
  name: 'ButtonLink',
  components: {
    RouterLinkSimple,
  },
  props: {
    buttonName: {
      type: String,
      default: '',
    },
    urlPart: {
      type: String,
      default: '',
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
